// Enumy

export enum DemandType {
    SEAT = 'demandSeat',
    TRADE = 'demandTrade',
}
export enum LegalForm {
    LEGAL = 'pravnicka',
    PHYSICAL = 'fyzicka',
}

export enum SeatAddressIn {
    SAME = 'stejnaObec',
    DIFFERENT = 'jinaObec',
}

export enum SeatInContract {
    ADDRESS = 'konkretniAdresa',
    VILLAGE = 'obec',
    DONT_KNOW = 'nevim',
}

// Produkt
export interface Product {
    type: string;
    name: string;
    code: string;
    amount: number;
    priceWithVat: string;
    priceWithoutVat: string;
    vatRate: number;
    amountUnit: number;
    jakeIsId: string;
}

// Základní demand (PHP: Demand)
export interface Demand {
    type: DemandType;
    email: string;
    phone: string;
    note: string;

    firstName: string;
    lastName: string;
    faStreet: string;
    faCity: string;
    faCountry: string;
    faZipCode: string;

    sourceUrl: string;
    sourceWeb: string;
    currency: string;

    products: Product[];

    lang: string;
    totalPriceWithVat: string;
    totalPriceWithoutVat: string;

    legalForm: LegalForm;
}

// Rozšířený SeatDemand
export interface SeatDemand extends Demand {
    seatChange: boolean;
    seatInContract: SeatInContract;
    seatAddressIn: SeatAddressIn;
    companyName: string | null;
    ico: string | null;
}